<template>
  <Layout :instruction="instruction">
    <template v-slot:title>
      <div>
        <span v-if="!isEditMode">{{ $t('instruction_view.create_new') }}</span>
        {{ $t('text_or_number') }} {{ $t('create_task.instruction') }}
      </div>
    </template>
    <template v-slot:content>
      <div class="content-wrapper">
        <b-field class="full-width">
          <b-input
            type="textarea"
            v-model="question"
            :disabled="loading"
          ></b-input>
        </b-field>
        <b-field>
          <b-checkbox v-model="pictureMandatory">
            {{ $t('picture_taken_is_mandatory') }}</b-checkbox
          >
        </b-field>
      </div>
    </template>
    <template v-slot:reference-image>
      <ReferenceImage :instructionProps="instruction" ref="refImage" />
    </template>
    <template v-slot:hyperlinks-documents>
      <HyperlinkButton
        @onLinkedInternalDocuments="onLinkedInternalDocuments"
        :instruction="instruction"
      />
    </template>
    <template v-slot:footer>
      <b-loading
        :is-full-page="true"
        v-model="loading"
        :can-cancel="false"
      ></b-loading>
      <b-button
        :disabled="!instruction"
        type="is-danger"
        @click="$emit('onDelete')"
        >{{ $t('admin_page.delete') }}</b-button
      >
      <b-button type="is-link" @click="$emit('onCancel')">{{
        $t('admin_page.cancel')
      }}</b-button>
      <b-button
        v-if="!instruction"
        type="is-success"
        :disabled="loading"
        @click="onSave"
        :loading="loadingButton"
        >{{ $t('admin_page.save') }}</b-button
      >
      <b-button
        v-if="instruction"
        type="is-success"
        @click="onUpdate"
        :loading="loadingButton"
        >{{ $t('admin_page.update') }}</b-button
      >
    </template>
  </Layout>
</template>

<script>
import Layout from './layout';
import ReferenceImage from '../ReferenceImage';
import { GET_LOADING_STATE } from '../../../../../store/loading/getters/getterTypes';
import KeyHandlerMixin from '../../../../../mixins/KeyHandlerMixin';
import HyperlinkButton from '../../../HyperlinkDocuments/HyperlinkButton';
import LinkedDocumentsMixin from '../../../HyperlinkDocuments/LinkedDocumentsMixin';

export default {
  name: 'textnumber',
  components: {
    Layout,
    ReferenceImage,
    HyperlinkButton,
  },
  mixins: [KeyHandlerMixin, LinkedDocumentsMixin],
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    instruction: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    if (this.instruction) {
      this.question = this.instruction.question;
      this.pictureMandatory = this.instruction.isPictureMandatory;
    }

    if (this.instruction) {
      this.setKeyHandlerCallback('update', this.onUpdate);
    } else {
      this.setKeyHandlerCallback('save', this.onSave);
    }
  },
  watch: {
    instruction(newVal) {
      if (newVal) {
        this.question = newVal.question;
      }
    },
  },
  data() {
    return {
      question: '',
      pictureMandatory: false,
      loadingButton: false,
    };
  },
  methods: {
    onSave() {
      const file = this.$refs.refImage?.file;
      const useImageReference = this.$refs.refImage?.useImageReference;
      this.loadingButton = true;
      this.$emit('onSave', {
        question: this.question,
        isPictureMandatory: this.pictureMandatory,
        type: 'textnumber',
        inputValue: '',
        file,
        useImageReference,
        linkedInternalDocuments: this.linkedInternalDocuments,
      });
    },
    onUpdate() {
      const file = this.$refs.refImage?.file;
      const useImageReference = this.$refs.refImage?.useImageReference;
      this.loadingButton = true;
      this.$emit('onUpdate', {
        _id: this.instruction._id,
        ...this.instruction,
        question: this.question,
        isPictureMandatory: this.pictureMandatory,
        type: 'textnumber',
        file,
        useImageReference,
        linkedInternalDocuments: this.linkedInternalDocuments,
      });
    },
  },
  computed: {
    loading() {
      return this.$store.getters[GET_LOADING_STATE];
    },
  },
};
</script>

<style scoped>
button {
  flex: 1;
}

.content-wrapper {
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 40px;
}

.full-width {
  width: 100%;
}
</style>
